/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type TradingSettingsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TradingSettingsQuery = {
	__typename?: "Query";
	tradingSettings: { __typename?: "TradingSettingsResponse"; marginTradingUnderlyingAssetId?: string | null };
};

export const TradingSettingsDocument = gql`
	query tradingSettings {
		tradingSettings {
			marginTradingUnderlyingAssetId
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class TradingSettingsGQLService extends Apollo.Query<TradingSettingsQuery, TradingSettingsQueryVariables> {
	document = TradingSettingsDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
